import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Control } from 'react-redux-form';


class CheckboxField extends Component {
  renderCheckbox() {
    const {
      displayName,
      attributeName,
      modelName,
      desiredClassName,
      onChange
    } = this.props;

    return(
      <div key={attributeName} className={`${desiredClassName}__field-group field`}>
        <label className={`${desiredClassName}__field-label`}>
          {displayName}
        </label>
        <span className={`${desiredClassName}__field-control control is-small checkbox`}>
          <Control.checkbox
            model={`${modelName}.${attributeName}`}
            onChange={onChange}
          />
        </span>
      </div>
    );
  }

  render() {
    return (
      <div className="checkbox-form-field">
        {this.renderCheckbox()}
      </div>
    );
  }
}

// NOTE: this is intended to work with a react-redux-form <Form />
CheckboxField.propTypes = {
  displayName: PropTypes.string.isRequired,
  attributeName: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  desiredClassName: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default CheckboxField;
